// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"5b858d3a","92":"2e787079","99":"fd58ed55","215":"636ca598","337":"657c8539","443":"5e4bebd8","453":"97da5409","479":"b28fb1e1","531":"3522ef71","952":"c46ff9e9"}[chunkId] + ".chunk.js";
};